import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import { Set_WmsInnModelCheckbox } from "../SliceWmsStockTransfer";
import {
  CmpTypographyField,
  CmpSelectField,
  CmpInputField,
} from "../../../Component/Common/ToolBox/ToolBox";
import MoreHorizOutlinedIcon from "@mui/icons-material/MoreHorizOutlined";

import GCToggleSearch from "../../../Component/Common/ReuseableComponent/GCToggleSearch";
import Grid from "@mui/material/Grid";
import GCTitleSticky from "../../../Component/Common/ReuseableComponent/GCTitleSticky";
import { CmpSelectFieldV1, CmpTextFieldV1 } from "../../../Component/Common/ToolBox/ToolBoxV1";
import GCToggleSearchV1 from "../../../Component/Common/ReuseableComponent/GCToggleSearchV1";
export default function GCContent({
  sTransItemStockObj,
  xTransItemStockShow,
  vRdxWmsHead,
  // xKey,
  // xFocusInput,
  xBufferObj,
  sUnit, 
  fUnit, 
  fQty_Save_onKeyUp, 
  fItemName,
  fOpenContentItemSearchModalKey,
  fQty,
  
  //toggle
  xMediaQuery,
  xonClickbtn,
  xrows,
  xcolumns,
  xRowCellClick,
  xRowClick,
  xToggle,
  xData,
  xOnChangeDropdownInput,
  xDropdownObj,
  xOnKeyUpDropdownInput,
  xErrorMsgDetail,
  xContent_Focus,
  xContent_Blur,
  fReason,
  sReason
}) {
  const dispatch = useDispatch();
  const vRdxCheckbox = useSelector(
    (state) => state.SliceWmsStockTransfer.value.WmsStockTransferCheckbox
  );
  const vModelCheckboxArr = [ 
    { name: "Tax", rdxName: vRdxCheckbox.Tax },  
  ];
  const [sIsChecked, setIsChecked] = useState(false);
  const [sGrnCheckBox, setGrnCheckbox] = useState(vRdxCheckbox);
  const [sOpenContentModal, setOpenContentModal] = useState(false);
  const fModalContentOpen = () => {
    setOpenContentModal(true);
  };

  const fModalContentClose = () => {
    setOpenContentModal(false);
  };
  const fSetCheckBox = (e) => {
    const nameValue = e.target.name;
    const iSCheck = e.target.checked;
    setGrnCheckbox((values) => ({ ...values, [nameValue]: iSCheck }));
  };
  const fIsAllChecked = (e) => {
    const iSCheck = e.target.checked;
    setIsChecked(iSCheck);
    setGrnCheckbox({
      SplDisc: iSCheck,
      TDiscPercent: iSCheck,
      TDiscAmt: iSCheck,
      LDiscPercent: iSCheck,
      LDiscAmt: iSCheck,
      // FOC: iSCheck,
      Excise: iSCheck,
      // BaseRate: iSCheck,
      Tax: iSCheck,
      // Rebate: iSCheck,
      // Narration: iSCheck,
      Cess: iSCheck,
      AddCess: iSCheck,
    });
  };
  useEffect(() => {
    dispatch(Set_WmsInnModelCheckbox(sGrnCheckBox));
    const vIsAllTrue = Object.values(sGrnCheckBox).every(
      (value) => value === true
    );
    setIsChecked(vIsAllTrue);
  }, [sGrnCheckBox, dispatch]);
  return (
    <form className="Wms-inbound-grn-content" id="WmsStockTransferContent">
      <Grid container spacing={0.9} columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
      <Grid
          item
          xs={12}
          sm={12}
          md={12}
          container
          textAlign={"end"}
          justifyContent={"end"}
        >
          <Grid
            item
            xs={12}
            sm={12}
            md={3}
            
          >
               {xMediaQuery ? ( <Grid
                container
                spacing={0}
                columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                className={
                  vRdxWmsHead.A_DocStat == "POST"
                    ? "hide-all-time"
                    : "d-flex justify-content-between align-items-center"
                }
              >
                <Grid item xs={4}>
                <CmpTypographyField
                xcomponent={"span"}
                xText={"Stock=" + sTransItemStockObj.RPStock}
              />
                  </Grid>
                <Grid item xs={4}   className={
                xTransItemStockShow >= 0 
                ? ""
                : "hide-all-time"
                }>
                <CmpTypographyField
                    xcomponent={"span"}
                    xText={" CostPr=" + sTransItemStockObj.CostPr}
                  />
                  </Grid>
                <Grid item xs={4}
                className={
                  xTransItemStockShow >= 0 
                     ? ""
                     : "hide-all-time"
                 }
                >
                <CmpTypographyField
                    xcomponent={"span"}
                    xText={"LPRate=" + sTransItemStockObj.LPRate}
                  />
                  </Grid>
               
                  </Grid>):(<div className="d-flex justify-content-between">
           
            <span
              className={
                vRdxWmsHead.A_DocStat === "POST"
                  ? "hide-all-time"
                  : "d-flex justify-content-between align-items-center"
              }
            >
              <CmpTypographyField
                xcomponent={"span"}
                xText={"Stock=" + sTransItemStockObj.RPStock}
              />{" "}
              &nbsp; &nbsp;
              {xTransItemStockShow >= 0 ? (
                <>
                  <CmpTypographyField
                    xcomponent={"span"}
                    xText={" CostPr=" + sTransItemStockObj.CostPr}
                  />
                  &nbsp;&nbsp;
                  <CmpTypographyField
                    xcomponent={"span"}
                    xText={"LPRate=" + sTransItemStockObj.LPRate}
                  />{" "}
                </>
              ) : (
                <></>
              )}
              &nbsp; &nbsp;
            </span>
          </div>)}
          </Grid>
          
          <Grid item xs={3} sm={3} md={3}>
           {/* <MoreHorizOutlinedIcon
              onClick={fModalContentOpen}
              className="form-label gnr-title-txt"
            /> */}
          </Grid>
        </Grid>
        {/* { !xMediaQuery &&     <Grid item xs={3} sm={3} md={1} className="lastkeyDetect">
          
     <CmpTextFieldV1
                    xLabelText="S.No"
            xValue={xBufferObj.B_Srno}
            xType={"text"} // text/number/password
            xName={"B_Srno"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_Srno === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Srno}
            // xOnKeyUp={xKey}
          />
        </Grid>} */}

        <Grid item xs={12} sm={3} md={2}  className="lastkeyDetect">
          <CmpTextFieldV1
            xLabelText="Item Code"
            xtabIndex={"101"}
            xValue={xBufferObj.B_Itmcd}
            xType={"text"} // text/number/password
            xName={"B_Itmcd"}
            xReadOnly={true}
            xOnChange={""}
            xError={xErrorMsgDetail.B_Itmcd === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Itmcd}
            // xOnKeyUp={xKey}
          />
        </Grid>

        <Grid
          item
          xs={12}
          sm={6}
          // md={"auto"}
          // lg={"auto"}
          md={xToggle?7.5:4} 
          className="lastkeyDetect"
        >
        
            <GCToggleSearchV1
            xLabelText="Item Name"
            xtabIndex={"102"}
            xName={"B_ItmName"}
            xType={"text"}
            xValue={xBufferObj?.B_ItmName}
            xReadOnly={false}
            xOnChange={fItemName}
            xOnKeyUp={fOpenContentItemSearchModalKey}
            xError={xErrorMsgDetail.B_ItmName === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_ItmName}
            xMediaQuery={xMediaQuery}
            xonClickbtn={xonClickbtn}
            xrows={xrows}
            xcolumns={xcolumns} //head
            xRowCellClick={xRowCellClick}
            xRowClick={xRowClick}
            xToggle={xToggle}
            xData={xData}
            xOnChangeDropdownInput={xOnChangeDropdownInput}
            xDropdownObj={xDropdownObj}
            xOnKeyUpDropdownInput={xOnKeyUpDropdownInput}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={2}  className="lastkeyDetect">
          <CmpTextFieldV1
            xLabelText="Qty"
            xtabIndex={"103"}
            xValue={xBufferObj.B_Qty}
            xType={"number"} // text/number/password
            xName={"B_Qty"}
            xReadOnly={false}
            xOnChange={fQty}
            xError={xErrorMsgDetail.B_Qty === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Qty}
            xonFocus={(e) => {
              xContent_Focus(e);
            }}
            xOnKeyUp={(e) => fQty_Save_onKeyUp(e)}
            xonBlur={xContent_Blur}
          />
        </Grid>
        <Grid item xs={4} sm={2} md={2}  className="lastkeyDetect">
     <CmpSelectFieldV1
            xtabIndex={"104"}
            xLabelText="Unit"
            xValue={xBufferObj.B_Unit}
            xOnChange={fUnit}
            xName={"B_Unit"}
            xData={sUnit}
            xValueMember={""}
            xDispalyMember={""}
            xError={xErrorMsgDetail.B_Unit === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.B_Unit}
            xDisable={false}
            xonBlur={xContent_Blur}
          />
        </Grid>
       { vRdxWmsHead.A_Type == 'OUTLET TO DC'&&<Grid item xs={4} sm={2} md={1} lg={1} className="lastkeyDetect">
           <CmpSelectFieldV1
            xtabIndex={"103"}
            xLabelText="Reason"
            xValue={xBufferObj.Reason}
            xOnChange={(e) => {
              fReason(e);
            }}
            xName={"Reason"}
            xData={sReason}
            xValueMember={""}
            xDispalyMember={""}
            xError={xErrorMsgDetail.Reason === "" ? false : true}
            xErrorMessage={xErrorMsgDetail.Reason}
            xDisable={false}


          />
        </Grid>}
       
      </Grid>

      <Modal
        open={sOpenContentModal}
        onClose={fModalContentClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-content-checkbox">
        <GCTitleSticky title={"Detail list"} onClose={fModalContentClose} />
        
           
          <div className="container-fluid">
            <div className="wms-label">
              <div className="checkbox-mb">
                <label className="form-label ">
                  <input
                    className="form-check-input "
                    type="checkbox"
                    name="AllChecked"
                    checked={sIsChecked}
                    onChange={(e) => {
                      fIsAllChecked(e);
                    }}
                  />{" "}
                  All
                </label>
              </div>
              <>
                {vModelCheckboxArr?.map((obj, index) => (
                  <div className="checkbox-mb" key={"Wmscheckbox" + index}>
                    <label className="form-label">
                      <input
                        className="form-check-input "
                        type="checkbox"
                        name={obj.name}
                        checked={obj.rdxName}
                        onChange={(e) => {
                          fSetCheckBox(e);
                        }}
                      />{" "}
                      {obj.name}
                    </label>
                  </div>
                ))}
              </>
            </div>
          </div>
        </Box>
      </Modal>
    </form>
  );
}
